<app-breadcrumb-options-docu-sign *ngIf="editPersonalInfo"></app-breadcrumb-options-docu-sign>
<div class="tab-pane active" role="tabpanel" id="step2">
    <div [ngClass]="{'container':editPersonalInfo}">
        <div class="panel panel-default">
            <div class="text-center pt-4" *ngIf="editPersonalInfo">
                <h2>Update Personal Information</h2>
            </div>
            <div class="panel-heading pt-2 pb-2" *ngIf="editPersonalInfo">
                <h4 class="nohr">Update your personal information</h4>
            </div>
            <div class="col-md-12 mt-5 additionalInfo" [ngClass]="{'ps-0': !editPersonalInfo}">
                <form [formGroup]="additionalInfoForm">
                    <ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="activeTabId" (activeIdChange)="onTabChange($event)" formArrayName="additionalInfoArr" *ngIf="editPersonalInfo && !isLoading">
                        <li [ngbNavItem]="index" *ngFor="let tab of additionalInfo; let index = index" [formGroupName]="index">
                            <a ngbNavLink (click)="clickedInfo(index)"
                                [attr.data-testid]="'docu-sign.additional-info.person-tab-' + index">
                                {{tab.user_attributes && tab.user_attributes.first_name?tab.user_attributes.first_name:'+'}}
                            </a>
                        </li>
                    </ul>

                    <!-- Manual tab content display for editable mode -->
                    <div class="mt-2" *ngIf="editPersonalInfo && !isLoading && additionalInfo.length > 0" formArrayName="additionalInfoArr">
                        <div *ngFor="let tab of additionalInfo; let index = index" [hidden]="activeTabId !== index">
                            <div [formGroupName]="index">
                                <div>
                                    <div class="pt-3">
                                        <div><strong>General Information</strong></div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12 form-css-label1 d-flex ps-0">
                                            <div class="col-md-4">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'first_name_' + index">First
                                                        Name</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" [(ngModel)]="tab.user_attributes.first_name"
                                                            formControlName="first_name" class="form-control"
                                                            [id]="'first_name_' + index"
                                                            [attr.data-testid]="'docu-sign.additional-info.first-name-input-' + index">
                                                        <div class="color-red"
                                                            *ngIf="informationFormSubmitted && additionalInfoFormMessageArr.controls[index]?.get('first_name')?.errors?.required">
                                                            First name is mandatory.
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'last_name_' + index">Last Name</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" [(ngModel)]="tab.user_attributes.last_name"
                                                            formControlName="last_name" class="form-control"
                                                            [id]="'last_name_' + index"
                                                            [attr.data-testid]="'docu-sign.additional-info.last-name-input-' + index">
                                                        <div class="color-red"
                                                            *ngIf="informationFormSubmitted && additionalInfoFormMessageArr.controls[index]?.get('last_name')?.errors?.required">
                                                            Last name is mandatory.
                                                        </div>
                                                    </fieldset>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 form-css-label1 d-flex ps-0">
                                            <div class="col-md-4">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'birthday_' + index">Birthday
                                                    </label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <div class="input-group">
                                                            <input type="text" #dp="bsDatepicker" bsDatepicker
                                                                formControlName="birthday"
                                                                [(ngModel)]="tab.user_attributes.birthday"
                                                                class="form-control"
                                                                [id]="'birthday_' + index"
                                                                [attr.data-testid]="'docu-sign.additional-info.birthday-input-' + index">
                                                            <span class="input-group-text cursor-pointer calendar-icon" (click)="dp.toggle()"
                                                                [attr.data-testid]="'docu-sign.additional-info.birthday-toggle-' + index"
                                                                [attr.aria-label]="'Toggle birthday calendar for person ' + (index + 1)"
                                                                role="button">
                                                                <i class="fa fa-calendar" aria-hidden="true"></i>
                                                            </span>
                                                        </div>
                                                        <div class="color-red"
                                                            *ngIf="informationFormSubmitted && additionalInfoFormMessageArr.controls[index].get('birthday').errors?.required">
                                                            Birthday is mandatory.
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'social_' + index">Social Security
                                                        Number
                                                    </label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="social"
                                                            [(ngModel)]="tab.user_attributes.social"
                                                            class="form-control"
                                                            [id]="'social_' + index"
                                                            [attr.data-testid]="'docu-sign.additional-info.ssn-input-' + index">
                                                        <div class="color-red"
                                                            *ngIf="informationFormSubmitted && additionalInfoFormMessageArr.controls[index].get('social').errors?.pattern">
                                                            Enter in 999-99-9999 format.
                                                        </div>
                                                    </fieldset>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-2">
                                        <div><strong>Contact Details</strong></div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12 form-css-label1 d-flex ps-0">
                                            <div class="col-md-4">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'email_' + index">Email</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="email"
                                                            [(ngModel)]="tab.user_attributes.email"
                                                            class="form-control"
                                                            [id]="'email_' + index"
                                                            [attr.data-testid]="'docu-sign.additional-info.email-input-' + index">
                                                    </fieldset>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'phone1_' + index">Phone
                                                        Number</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="phone1"
                                                            [(ngModel)]="tab.user_attributes.primary_phone"
                                                            class="form-control" appPhoneMask
                                                            [id]="'phone1_' + index"
                                                            [attr.data-testid]="'docu-sign.additional-info.phone-input-' + index">
                                                            <div class="color-red"
                                                            *ngIf="informationFormSubmitted && additionalInfoFormMessageArr.controls[index].get('phone1').errors?.invalidPhoneLength">
                                                                Phone number must be at least 10 characters long.
                                                            </div>
                                                    </fieldset>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 form-css-label1 d-flex ps-0">
                                            <div class="col-md-8">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'address1_' + index">Address</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="address1" id="typeahead-format" [ngbTypeahead]="searchAddress" [resultFormatter]="formatAddress" [inputFormatter]="inputAddressFormat" autocomplete="off" [(ngModel)]="tab.user_attributes.address1"
                                                        (selectItem)="selectedAddress($event, index)" class="form-control"
                                                        [attr.data-testid]="'docu-sign.additional-info.address-input-' + index"
                                                        [attr.aria-label]="'Address for person ' + (index + 1)">
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 form-css-label1 d-flex ps-0">
                                            <div class="col-md-3">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'city_' + index">City</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="city"
                                                            [(ngModel)]="tab.user_attributes.city" class="form-control"
                                                            [id]="'city_' + index"
                                                            [attr.data-testid]="'docu-sign.additional-info.city-input-' + index">
                                                    </fieldset>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="p-1">
                                                    <label class="fw-bold text-secondary"></label>
                                                </div>
                                                <div class="pb-3 dropdown" ngbDropdown>
                                                    <button type="button"
                                                        class="btn btn-outline-secondary dropdown-toggle rounded-pill select-wrp-country open ps-3 pe-3 font-14"
                                                        ngbDropdownToggle
                                                        [attr.data-testid]="'docu-sign.additional-info.state-dropdown-' + index"
                                                        [attr.aria-label]="'Select state for person ' + (index + 1)">
                                                        {{tab.user_attributes.state?tab.user_attributes.state:"Select State"}}
                                                    </button>
                                                    <div class="dropdown-menu select-list scroll-list" ngbDropdownMenu>
                                                        <a *ngFor="let state of stateList"
                                                            class="dropdown-item cursor-pointer font-14 p-2"
                                                            ngbDropdownItem
                                                            (click)="tab.user_attributes.state = state.name">{{state.name}}</a>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'zipcode_' + index">Zip Code</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="zipcode"
                                                            [(ngModel)]="tab.user_attributes.zipcode"
                                                            class="form-control"
                                                            [id]="'zipcode_' + index"
                                                            [attr.data-testid]="'docu-sign.additional-info.zipcode-input-' + index">
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-2">
                                        <div><strong>Employment Details
                                            </strong></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 form-css-label1 d-flex ps-0">

                                            <div class="col-md-3">
                                                <div>
                                                    <label class="fw-bold text-secondary">Status</label>
                                                </div>


                                                <div class="pb-3 dropdown" ngbDropdown>
                                                    <button type="button"
                                                        class="btn btn-outline-secondary dropdown-toggle rounded-pill select-wrp-country open ps-3 pe-3 font-14"
                                                        ngbDropdownToggle
                                                        [attr.data-testid]="'docu-sign.additional-info.employer-status-dropdown-' + index"
                                                        [attr.aria-label]="'Select employment status for person ' + (index + 1)">
                                                        {{tab.user_attributes.employer_status?tab.user_attributes.employer_status:"Select Status"}}
                                                    </button>
                                                    <div class="dropdown-menu select-list scroll-list employee-data-list" ngbDropdownMenu>
                                                        <a *ngFor="let status of statusList"
                                                            class="dropdown-item cursor-pointer font-14 p-2"
                                                            ngbDropdownItem
                                                            (click)="tab.user_attributes.employer_status = status[0]">{{status[0]}}</a>
                                                    </div>

                                                </div>

                                            </div>
                                            <div class="col-md-5">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'employerName_' + index">Employer
                                                        Name</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input id="employerName_{{index}}" name="employerName_{{index}}"
                                                            formControlName="employer_name" type="text"
                                                            [(ngModel)]="tab.user_attributes.employer_name"
                                                            class="form-control"
                                                            [attr.data-testid]="'docu-sign.additional-info.employer-name-input-' + index">
                                                    </fieldset>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 form-css-label1 d-flex ps-0">

                                            <div class="col-md-3">
                                                <div>
                                                    <label class="fw-bold text-secondary">Occupation</label>
                                                </div>

                                                <div class="pb-3 dropdown" ngbDropdown>
                                                    <button type="button"
                                                        class="btn btn-outline-secondary dropdown-toggle rounded-pill select-wrp-country select-wrp-content open ps-3 pe-3 font-14"
                                                        ngbDropdownToggle
                                                        [attr.data-testid]="'docu-sign.additional-info.occupation-dropdown-' + index"
                                                        [attr.aria-label]="'Select occupation for person ' + (index + 1)">
                                                        {{tab.user_attributes.user_employer_occupation_name?tab.user_attributes.user_employer_occupation_name:"Select Occupation"}}
                                                    </button>
                                                    <div class="dropdown-menu select-list scroll-list" ngbDropdownMenu>
                                                        <a *ngFor="let occupation of empOccupationCodesArr"
                                                            class="dropdown-item cursor-pointer font-14 p-2"
                                                            ngbDropdownItem
                                                            (click)="tab.user_attributes.user_employer_occupation_name = occupation[1];
                                                            tab.user_attributes.user_employer_occupation_id = occupation[0]">{{occupation[1]}}</a>
                                                    </div>

                                                </div>

                                            </div>
                                            <div class="col-md-4">
                                                <div>
                                                    <label class="fw-bold text-secondary">Type of
                                                        Business
                                                    </label>
                                                </div>
                                                <div class="pb-3 dropdown" ngbDropdown>
                                                    <button type="button"
                                                        class="btn btn-outline-secondary dropdown-toggle rounded-pill select-wrp-country select-wrp-content open ps-3 pe-3 font-14"
                                                        ngbDropdownToggle
                                                        [attr.data-testid]="'docu-sign.additional-info.industry-dropdown-' + index"
                                                        [attr.aria-label]="'Select type of business for person ' + (index + 1)">
                                                        {{tab.user_attributes.user_employer_industry_name?tab.user_attributes.user_employer_industry_name:"Select Industry"}}
                                                    </button>
                                                    <div class="dropdown-menu select-list scroll-list" ngbDropdownMenu>
                                                        <a *ngFor="let industry of empIndustryCodesArr"
                                                            class="dropdown-item cursor-pointer font-14 p-2"
                                                            ngbDropdownItem
                                                            (click)="tab.user_attributes.user_employer_industry_name= industry[1];
                                                                tab.user_attributes.user_employer_industry_id = industry[0]">{{industry[1]}}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row pt-2">
                                        <div class="col-md-12 form-css-label1 d-flex ps-0">
                                            <div class="col-md-3">
                                                <div>
                                                    <label class="fw-bold text-secondary">Country</label>
                                                </div>
                                                <div class="pb-3 dropdown" ngbDropdown>
                                                    <button type="button"
                                                        class="btn btn-outline-secondary dropdown-toggle rounded-pill select-wrp-country open ps-3 pe-3 font-14 w-100"
                                                        ngbDropdownToggle
                                                        [attr.data-testid]="'docu-sign.additional-info.employer-country-dropdown-' + index"
                                                        [attr.aria-label]="'Select employer country for person ' + (index + 1)">
                                                        {{tab.user_attributes.employer_country_name || 'United States'}}
                                                    </button>
                                                    <div class="dropdown-menu select-list scroll-list" ngbDropdownMenu>
                                                        <a *ngFor="let country of countryList"
                                                            class="dropdown-item cursor-pointer font-14 p-2"
                                                            ngbDropdownItem
                                                            (click)="onEmployerCountryChange(index, country.code)">{{country.name}}</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'employer_address_' + index">Employer
                                                        Address</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="employer_address"
                                                             [(ngModel)]="tab.user_attributes.employer_address"
                                                             class="form-control"
                                                             autocomplete="off"
                                                             [id]="'employer_address_' + index"
                                                             [attr.data-testid]="'docu-sign.additional-info.employer-address-input-' + index">
                                                             <!-- Melissa validation commented out -->
                                                             <!-- id="typeahead-format"
                                                             (keyup)="isUSEmployerAddress(index) ? getAddressList($event) : null"
                                                             [resultFormatter]="formatAddress"
                                                             [inputFormatter]="inputAddressFormat"
                                                            (selectItem)="selectedEmployerAddress($event, index)" -->
                                                    </fieldset>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 form-css-label1 d-flex ps-0">
                                            <div class="col-md-3">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'employer_city_' + index">City</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="employer_city"
                                                            [(ngModel)]="tab.user_attributes.employer_city"
                                                            class="form-control"
                                                            [id]="'employer_city_' + index"
                                                            [attr.data-testid]="'docu-sign.additional-info.employer-city-input-' + index">
                                                    </fieldset>
                                                </div>
                                            </div>

                                            <div class="col-md-3">
                                                <div>
                                                    <label class="fw-bold text-secondary">State/Province</label>
                                                </div>

                                                <!-- State/Province dropdown for countries with defined states -->
                                                <div class="pb-3 dropdown" ngbDropdown >
                                                    <button type="button"
                                                        class="btn btn-outline-secondary dropdown-toggle rounded-pill select-wrp-country open ps-3 pe-3 font-14 w-100"
                                                        ngbDropdownToggle
                                                        [attr.data-testid]="'docu-sign.additional-info.employer-state-dropdown-' + index"
                                                        [attr.aria-label]="'Select employer state/province for person ' + (index + 1)">
                                                        {{tab.user_attributes.employer_state?tab.user_attributes.employer_state:"Select"}}
                                                    </button>
                                                    <div class="dropdown-menu select-list scroll-list" ngbDropdownMenu>
                                                        <a *ngFor="let state of employerStateList[index]"
                                                            class="dropdown-item cursor-pointer font-14 p-2"
                                                            ngbDropdownItem
                                                            (click)="tab.user_attributes.employer_state = state.name">{{state.name}}</a>

                                                    </div>
                                                </div>

                                                <!-- Free text input for countries without defined states (Other) -->
                                                <div *ngIf="!hasEmployerStateList(index)">
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="employer_state"
                                                            [(ngModel)]="tab.user_attributes.employer_state"
                                                            class="form-control"
                                                            placeholder="Region"
                                                            [attr.data-testid]="'docu-sign.additional-info.employer-region-input-' + index"
                                                            [attr.aria-label]="'Employer region/state for person ' + (index + 1)">
                                                    </fieldset>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div>
                                                    <label class="fw-bold text-secondary" [attr.for]="'employer_zipcode_' + index">Zip Code</label>
                                                </div>
                                                <div>
                                                    <fieldset class="form-group">
                                                        <input type="text" formControlName="employer_zipcode"
                                                            [(ngModel)]="tab.user_attributes.employer_zipcode"
                                                            class="form-control"
                                                            [id]="'employer_zipcode_' + index"
                                                            [attr.data-testid]="'docu-sign.additional-info.employer-zipcode-input-' + index">
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul ngbNav #navReadOnly="ngbNav" class="nav-tabs" [(activeId)]="activeTabId" *ngIf="!editPersonalInfo && !isLoading">
                        <ng-container *ngFor="let tab of additionalInfo; let i = index">
                            <li [ngbNavItem]="'person' + i" *ngIf="tab.user_attributes.category != 'Deceased'">
                                <a ngbNavLink
                                    [attr.data-testid]="'docu-sign.additional-info.readonly-tab-' + i">{{tab.user_attributes.first_name}}</a>
                            </li>
                        </ng-container>
                    </ul>

                    <!-- Manual tab content display for read-only mode -->
                    <div class="mt-2" *ngIf="!editPersonalInfo && !isLoading && additionalInfo.length > 0">
                        <div *ngFor="let tab of additionalInfo; let i = index" [hidden]="activeTabId.toString() !== ('person' + i)">
                            <div *ngIf="tab.user_attributes.category != 'Deceased'">
                                <div>
                                    <div class="pt-3">
                                        <div><strong>General Information</strong></div>
                                    </div>
                                    <div class="pt-4">
                                        <a class="advLink sml-txt color-purple cursor-pointer"
                                            (click)="openContactUsModal('profile')"
                                            data-testid="docu-sign.additional-info.contact-advisor-link">Contact My Advisor to
                                            Edit
                                        </a>

                                    </div>
                                    <div class="row pt-4">
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Full
                                                    Name</label>
                                            </div>
                                            <div>
                                                <label class="font-normal">
                                                    {{tab.user_attributes.displayFullName}}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Birthday</label>
                                            </div>
                                            <div>
                                                <label class="font-normal">
                                                    {{tab.user_attributes.birthday | date :'MMMM d, yyyy' }}
                                                </label>


                                            </div>

                                        </div>
                                    </div>
                                    <div class="pt-4">
                                        <div><strong>Contact Details</strong></div>
                                    </div>

                                    <div class="row pt-4">
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Email</label>
                                            </div>
                                            <div>
                                                {{tab.user_attributes.email}}
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Phone
                                                    Number</label>
                                            </div>
                                            <div>
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.primary_phone">{{tab.user_attributes.primary_phone_type}}:&nbsp;
                                                </label>
                                                <label class="font-normal"
                                                    ng-bind="tab.user_attributes.phone1">{{tab.user_attributes.primary_phone | phoneFormatter}}</label>
                                            </div>

                                        </div>
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Address</label>
                                            </div>
                                            <div>
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.address1">{{tab.user_attributes.address1}}
                                                </label><br>
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.address2">{{tab.user_attributes.address2}}
                                                </label><br>
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.city">{{tab.user_attributes.city}}&nbsp;
                                                </label>
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.state">{{tab.user_attributes.state}}&nbsp;</label>
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.zipcode">{{tab.user_attributes.zipcode}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-4">
                                        <div><strong>Employment Details
                                            </strong></div>
                                    </div>
                                    <div class="row pt-4">
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Status</label>
                                            </div>
                                            <div>
                                                <label class="font-normal">
                                                    {{tab.user_attributes.employer_status}}

                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Employer
                                                    Name</label>
                                            </div>
                                            <div>
                                                <label class="font-normal">
                                                    {{ tab.user_attributes.employer_name}}
                                                </label>
                                            </div>

                                        </div>
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Occupation</label>
                                            </div>
                                            <div>
                                                {{tab.user_attributes.user_employer_occupation_name}}
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row pt-4">
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Type of
                                                    Business
                                                </label>
                                            </div>
                                            <div>
                                                <label class="font-normal">
                                                    {{tab.user_attributes.user_employer_industry_name}}

                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div>
                                                <label class="fw-bold text-secondary">Employer
                                                    Address</label>
                                            </div>
                                            <div>
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.employer_address">{{tab.user_attributes.employer_address}}</label><br
                                                    *ngIf="tab.user_attributes.employer_address">
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.employer_address2">{{tab.user_attributes.employer_address2}}</label><br
                                                    *ngIf="tab.user_attributes.employer_address2">
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.employer_city">{{tab.user_attributes.employer_city}} &nbsp;</label>
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.employer_state">{{tab.user_attributes.employer_state}}&nbsp;
                                                </label>
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.employer_zipcode">{{tab.user_attributes.employer_zipcode}}</label>
                                                <br *ngIf="tab.user_attributes.employer_country_name && tab.user_attributes.employer_country !== 'US'">
                                                <label class="font-normal"
                                                    *ngIf="tab.user_attributes.employer_country_name && tab.user_attributes.employer_country !== 'US'">{{tab.user_attributes.employer_country_name}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div *ngIf="editPersonalInfo && !isLoading">
                    <app-buttonbar (clickedprev)="gotoPreviousState()" (clickednext)="validateAddress('true')">
                    </app-buttonbar>
                </div>
            </div>

        </div>
    </div>
</div>
